import React, { createContext, useState, useCallback } from "react";

export const GuideContext = createContext({
  guideMode: false,
  toggleGuideMode: () => {},
});

export const GuideProvider = ({ children }) => {
  const [guideMode, setGuideMode] = useState(false);

  const toggleGuideMode = useCallback(() => {
    setGuideMode((prev) => !prev);
  }, []);

  return (
    <GuideContext.Provider value={{ guideMode, toggleGuideMode }}>
      {children}
    </GuideContext.Provider>
  );
};
